module.exports = __webpack_public_path__ + "img/close.8df2fa7e.svg";